import { CdkListbox } from '@angular/cdk/listbox';
import { ChangeDetectionStrategy, Component, HostBinding, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { SelectService } from './select.service';

@Component({
  selector: 'tt-select-items',
  standalone: true,
  imports: [],
  hostDirectives: [CdkListbox],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['select-content.component.scss'],
  template: ` <ng-content /> `,
})
export class SelectItemsComponent {
  private service = inject(SelectService);
  private cdkListbox = inject(CdkListbox, { host: true });

  @HostBinding('attr.data-state') get dataState() {
    return this.service.overlayState() ?? 'open';
  }

  @HostBinding('attr.data-side') get dataSide() {
    return this.service.side() ?? 'bottom';
  }

  constructor() {
    this.cdkListbox.valueChange
      .asObservable()
      .pipe(takeUntilDestroyed())
      .subscribe((val) => {
        this.service.listBoxValueChangeEvent$.next(val);
      });
  }

  /**
   * Focuses the listbox element.
   */
  public focusList() {
    this.cdkListbox.focus();
  }
}
